import querystring from 'querystring';
import { pickBy } from 'lodash';

import splitHashParams from './splitHashParams';

import { Params } from './types';

const filterEmptyKeys = (obj: Params) => pickBy(obj, (_, key) => !!key);

const extractParamsFromHash = (url = '') => {
  const params = querystring.parse(splitHashParams(url).queryString);
  // Handles a params object that was extracted from an URL with a trailing `&`,
  // which would result in an empty key/value pair.
  return filterEmptyKeys(params);
};

export default extractParamsFromHash;
